module.exports = __webpack_public_path__ + "img/12_77.5f61b81e.png";